import { FiRrInfo } from '@app/assets';
import { useTranslation } from 'react-i18next';

export const GlobalSettingsBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-3 items-start rounded-lg bg-gray-200 border border-gray-300 px-3 py-2">
      <FiRrInfo className="shrink-0 text-accept-main" />
      <div className="flex flex-col gap-3">
        <p className="flex gap-1 flex-wrap text-xs text-gray-800">{t('qr.settings.global.bannerMessage')}</p>
      </div>
    </div>
  );
};
